import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { notification } from 'antd'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditTourPayload } from '@app-store/slices/tours/edit'

interface TaskAction extends Action {
    payload: IEditTourPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.tours.edit

function* editTourSagaTask({ payload }) {
    try {
        const response = yield axios.patch(`/event/tour/${payload.id}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
            notification.success({
                message: 'Tour updated successfully.'
            })
        } else {
            yield payload.sagaCB?.onError()
            throw new Error('')
        }
    } catch (error) {
        yield payload.sagaCB?.onError()
        yield put(onFailure(error))
    }
}

function* editTourSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editTourSagaTask)
}

export default editTourSaga
